"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HelperUtils_1 = require("utils/HelperUtils");
const SettingDeadline_1 = __importDefault(require("./fragments/SettingDeadline"));
const SettingEmailNotificationReviewees_1 = __importDefault(require("./fragments/SettingEmailNotificationReviewees"));
const SettingEmailNotificationStakeholders_1 = __importDefault(require("./fragments/SettingEmailNotificationStakeholders"));
const SetupConfiguration = react_1.default.memo(() => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("p", { className: "typography-h500 text-n-900 mb-[4px]" }, (0, HelperUtils_1.getObjectiveLocale)('Configuration for New Reviewees')),
        react_1.default.createElement("p", { className: "typography-h100 text-n-800 mb-[24px]" }, (0, HelperUtils_1.getObjectiveLocale)('Setup review deadline and email notification for these reviewees.')),
        react_1.default.createElement(SettingDeadline_1.default, null),
        react_1.default.createElement(SettingEmailNotificationReviewees_1.default, null),
        react_1.default.createElement(SettingEmailNotificationStakeholders_1.default, null)));
});
SetupConfiguration.displayName = 'SetupConfiguration';
exports.default = SetupConfiguration;
